import { Map as ImmutableMap } from 'immutable';
import { buildTypedMap } from '../types/TypedMap';
import { OWNERS_FETCH_STARTED, OWNERS_FETCH_SUCCEEDED } from '../actions/ActionTypes';
import { STARTED, UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
const initialState = buildTypedMap({
  status: UNINITIALIZED,
  owners: ImmutableMap()
});
export default function owners(state = initialState, action) {
  switch (action.type) {
    case OWNERS_FETCH_STARTED:
      return state.merge({
        status: STARTED
      });
    case OWNERS_FETCH_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          status: SUCCEEDED,
          owners: payload
        });
      }
    default:
      return state;
  }
}